import { computed } from 'vue';

export function isRegion(region) {
    return computed(() => process.env.VUE_APP_REGION === region);
}


export const isUSRegion = () => isRegion('US');
export const isAustraliaRegion = () => isRegion('AU');